import * as React from 'react';

const NEWS_FEED_DELAY_AFTER_SEGMENT_MS = 1000;

type UseNewsFeedEnabledParams = {
  managerId: string | undefined;
  showSegment: boolean | null;
};

const useNewsFeedEnabled = ({
  managerId,
  showSegment
}: UseNewsFeedEnabledParams): boolean => {
  const [isNewsFeedEnabled, setIsNewsFeedEnabled] = React.useState(false);
  const previousSegmentStateRef = React.useRef({
    managerId: undefined as string | undefined,
    showSegment: null as boolean | null
  });

  React.useEffect(() => {
    const previousSegmentState = previousSegmentStateRef.current;
    const shouldDelayNewsFeed =
      previousSegmentState.managerId === managerId &&
      previousSegmentState.showSegment === true &&
      showSegment === false;

    previousSegmentStateRef.current = { managerId, showSegment };

    if (!managerId || showSegment !== false) {
      setIsNewsFeedEnabled(false);
      return;
    }

    if (!shouldDelayNewsFeed) {
      setIsNewsFeedEnabled(true);
      return;
    }

    setIsNewsFeedEnabled(false);
    const timeoutId = window.setTimeout(
      () => setIsNewsFeedEnabled(true),
      NEWS_FEED_DELAY_AFTER_SEGMENT_MS
    );

    return () => window.clearTimeout(timeoutId);
  }, [managerId, showSegment]);

  return isNewsFeedEnabled;
};

export default useNewsFeedEnabled;
